





















































































import { Component, Vue, Prop } from "vue-property-decorator";
import configList from "./config";
@Component({
  components: {},
})
export default class Home extends Vue {
  @Prop({ type: Number, default: 0 })
  public type;
  public value = "";
  public value2: any = "";
  public active = 0;
  public model = 0;
  public gameid = 0;
  public serverid = 0;
  public gameList = configList;
  public payList = [10, 20, 30, 50, 100, 200, 300, 500, 1000, 2000, 3000];
  // public mounted() {}
  public change() {
    if (this.value2 < 10) {
      this.value2 = 10;
    } else if (this.value2 > 3000) {
      this.value2 = 3000;
    }
  }
}
